export default "__VITE_ASSET__DmNwi5Xy__"